export var ActivitySuggestionStatus;
(function (ActivitySuggestionStatus) {
    ActivitySuggestionStatus["OnReview"] = "OnReview";
    ActivitySuggestionStatus["Accepted"] = "Accepted";
    ActivitySuggestionStatus["Declined"] = "Declined";
})(ActivitySuggestionStatus || (ActivitySuggestionStatus = {}));
